import {CURVAS_CREDITO_WORKFLOWS_PATH} from "src/utils/api-routes"
import {ServiceRequest} from "src/utils/service-request"


export class CurvasCreditoWorkflowService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async listRuns({workflowType = "", limit = 200} = {}) {
        const params = new URLSearchParams({limit: String(limit)})
        if (workflowType) {
            params.append("workflow_type", workflowType)
        }

        return this.request.get(`${CURVAS_CREDITO_WORKFLOWS_PATH}?${params.toString()}`)
    }

    async startWorkflow({
        workflowType,
        dataInicial,
        dataFinal,
        verticesFile,
        resumoFile,
        useGpu,
    }) {
        const formData = new FormData()
        formData.append("workflow_type", workflowType)
        formData.append("data_inicial", dataInicial)
        formData.append("data_final", dataFinal)
        formData.append("vertices_file", verticesFile)
        formData.append("resumo_file", resumoFile)
        formData.append("use_gpu", String(Boolean(useGpu)))
        formData.append("keep_temp_files", "false")

        return this.request.postFormData(CURVAS_CREDITO_WORKFLOWS_PATH, formData)
    }

    async getDownload(downloadEndpoint) {
        return this.request.get(downloadEndpoint)
    }
}
